import { compose, withProps, branch, renderComponent } from 'recompose';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  loggedUserIdSelector,
  hasProviderProfileSelector,
} from '../../../redux/context/selectors';
import {
  membersListSelector,
  moderatorsListSelector,
  membersCountSelector,
  moderatorsCountSelector,
} from './selectors';
import Loader from '../../common/Loader';
import { COMMUNITY_TYPES } from '../../../constants/props';
import withPopoverMenu from '../../../hocs/withPopoverMenu';
import * as sendMessage from '../../../redux/chatConnection/sendMessage';
import { actions as membersActions } from '../../../redux/communities/communityMembers';
import { currentCommunityIdSelector } from '../../../redux/communities/selectors/selectors';
import { actions as moderatorsActions } from '../../../redux/communities/communityModerators';
import { actions as removeUserCommunityActions } from '../../../redux/communities/removeUserCommunity';
import { isCurrentCommunityModeratorSelector } from '../../../redux/communities/selectors/currentCommunity';
import styles from './index.styl';

const mapDispatchToProps = dispatch => {
  return {
    sendMessage: message => dispatch(sendMessage.actions.send(message)),
    fetchMembers: communityId =>
      dispatch(membersActions.getMembers({ communityId })),
    fetchModerators: communityId =>
      dispatch(moderatorsActions.getModerators({ communityId })),
    clearMembers: () => dispatch(membersActions.clearMembers()),
    clearModerators: () => dispatch(moderatorsActions.clearModerators()),
    removeUserCommunity: (userType, communityId, memberId) =>
      dispatch(
        removeUserCommunityActions.send({ userType, communityId, memberId }),
      ),
  };
};

const mapStateToProps = state => ({
  loggedUserId: loggedUserIdSelector(state),
  membersList: membersListSelector(state),
  moderatorsList: moderatorsListSelector(state),
  communityId: currentCommunityIdSelector(state),
  isLoggedUserProvider: hasProviderProfileSelector(state),
  membersCount: membersCountSelector(state),
  moderatorsCount: moderatorsCountSelector(state),
  isModerator: isCurrentCommunityModeratorSelector(state),
});

export const enhance = compose(
  branch(({ community }) => !community.id, renderComponent(Loader)),
  withPopoverMenu,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({
      membersList,
      moderatorsList,
      community: { currentUserRole, type },
      moderatorsCount,
      membersCount,
      intl: { formatMessage },
    }) => {
      return {
        shouldLoadMoreMembers: Boolean(
          membersList.length && membersCount > membersList.length,
        ),
        shouldLoadMoreModerators: Boolean(
          moderatorsList.length && moderatorsCount > moderatorsList.length,
        ),
        isPublic: type === COMMUNITY_TYPES.public,
        isMember: Boolean(currentUserRole),
        formatMessage,
      };
    },
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Community/About/enhance.js